import { useParams } from 'react-router-dom';
import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { timeStampToDate } from '@utils/index';
import { useQuery } from 'react-query';

import { realtorBookingConstants, realtorBookingModels } from '..';

export function useOneRealtorBooking() {
  const param = useParams();
  const { id } = useAppSelector(({ realtorBookingReducer }) => realtorBookingReducer.view);
  const bookingId = id || Number(param?.id);

  const { data, ...arg } = useQuery<{
    booking: realtorBookingModels.OneRealtorBookingType;
  }>(
    [realtorBookingConstants.queryKeys.ONE_BOOKING, bookingId],
    async () => {
      const { data } = await $api.get(`/v1/realtor-booking/${bookingId}`);

      const booking: realtorBookingModels.OneRealtorBookingType = data?.data;

      return {
        booking: booking
          ? {
            ...booking,
            createdDate: timeStampToDate({ date: booking?.createdDate, timeStamp: booking?.createdTimestamp })
          }
          : booking
      };
    },
    {
      retry: false,
      enabled: !!bookingId
    }
  );

  return { ...data, ...arg };
}
